import { render, staticRenderFns } from "./ZwaveConfiguration.vue?vue&type=template&id=2f2c9d2c&"
import script from "./ZwaveConfiguration.vue?vue&type=script&lang=js&"
export * from "./ZwaveConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports